<section class="canvas-tour-tooltip" [class.multi-line]="!oneLine">
  @if (oneLine){
    <div class="tour-text">{{tour.text}}</div>
  } @else {
    <div class="tour-text">
      <div class="title" [innerHTML]="tour.title"></div>
      <div class="description">{{tour.description}}</div>
    </div>
  }
</section>
